<app-facet-expansion-panel
  [facetKey]="facetKey"
  [count]="_checked ? 1 : 0"
  [expanded]="expanded"
  [blockName]="facetBlockName"
  [attr.data-automation-id]="facetKey">
  <div class="d-flex align-items-center">
    <fieldset class="facet px-8 d-flex flex-column">
      <legend class="cdk-visually-hidden">{{facetBlockName}}</legend>
      <div class="facet-line d-inline-flex align-items-center" [ngClass]="{'can-hover': (catalogDate)}">
        <ng-container>
          <button
            class="facet-lock position-absolute p-0 ml-n3"
            (click)="onToggleBubbleLock()"
            [ngClass]="{'hide': !_checked}"
            aria-label="Lock"
            data-automation-id="catalog-date-facet-lock-btn">
            <span [ngClass]="isResetLocked ? 'icon-lock' : 'icon-lock-open'"></span>
          </button>
        </ng-container>
        <ins-bs-checkbox
          class="facet-checkbox"
          [checked]="_checked"
          [disabled]="!catalogDate"
          [ngClass]="{'selected': _checked, 'hide': !catalogDate}"
          (change)="onCheckboxChange($event.checked)"
          [aria-label]="catalogDate"
          data-automation-id="catalog-date-facet-checkbox">
        </ins-bs-checkbox>
        <ng-container>
          <div class="facet-select-period">
            <label [for]="selectBoxId" translate>selectPeriod</label>
            <select
              (change)="onCatalogDateChange($event.target.value)"
              [value]="catalogDate"
              [id]="selectBoxId"
              class="form-select form-select-lg catalog-date-facet-select"
              data-automation-id="catalog-date-facet-select">
              <option
                *ngFor="let periodOption of periodOptions"
                [value]="periodOption.value"
                data-automation-id="catalog-date-facet-option">
                {{periodOption.title | translate}}
              </option>
            </select>
          </div>
        </ng-container>
      </div>
    </fieldset>
    <div class="d-flex justify-content-center mb-1" *ngIf="isLoading | async">
      <div class="spinner-border text-primary" role="status" data-automation-id="catalog-date-facet-spinner">
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>
  </div>
</app-facet-expansion-panel>
